/**
 * What-if prepayment helpers for the amortization page. Pure — no React — so they
 * can be unit-tested on their own.
 */

// Money on this page always shows cents ($10,785.40, $420,000.00), matching the PDF.
// The shared formatNumberIntoCurrency drops trailing zeros ($10,785.4).
export const formatMoney = (value, placeholder = '$0.00') => {
  if (value === null || value === undefined || value === '') return placeholder;
  const number = Number(value);
  if (!Number.isFinite(number)) return placeholder;
  return number.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// The what-if levers, in the names the page form and the API share.
export const WHAT_IF_KEYS = [
  'extra_monthly',
  'monthly_growth_pct',
  'lump_sum',
  'lump_sum_month',
  'annual_extra',
  'annual_growth_pct',
];

/**
 * A scenario carried on a link (Mira AI's "Open the schedule"), as form values, or
 * null when the link carries none. Only positive plain numbers are taken, and the
 * lump-sum payment number only as a whole number, so a malformed link opens the
 * plain schedule rather than a half-filled form.
 */
export const whatIfFromParams = (params) => {
  if (!params?.get) return null;
  const draft = Object.fromEntries(WHAT_IF_KEYS.map((key) => [key, '']));
  let found = false;
  WHAT_IF_KEYS.forEach((key) => {
    const raw = String(params.get(key) ?? '').trim();
    const pattern = key === 'lump_sum_month' ? /^\d+$/ : /^\d+(\.\d+)?$/;
    if (!pattern.test(raw) || !(Number(raw) > 0)) return;
    draft[key] = raw;
    found = true;
  });
  // A payment number on its own is not a scenario.
  if (draft.lump_sum_month && !draft.lump_sum) draft.lump_sum_month = '';
  return found && WHAT_IF_KEYS.some((key) => key !== 'lump_sum_month' && draft[key]) ? draft : null;
};
